import { Dispatch } from 'redux';
import { apiAction } from '../../../TCSMApp/global/ducks/base-api';
import { ApiAction, HttpMethods } from '../../../TCSMApp/global/models/api-model';
import { MailMessage } from '../components/mail/mail-model';
import { ApiEndpoint } from '../constants/api-endpoints';
import { cleargyDetailPath } from './clergy-api';
import { parishDetailPath } from './parish-api';

export const sendMailPath = '/send_email.json';

export function SendMail(
	mailMessage: MailMessage, 
	isClergy: boolean,	
	onSuccess: (data: any, dispatch?: Dispatch<any>) => any, 
	onFailure?: (dispatch?: Dispatch<any>) => any,
	): ApiAction {

	const payloadData = {
		name: mailMessage?.name,
		email: mailMessage?.email,		
		message: mailMessage?.message,
		'g-recaptcha-response-data': mailMessage?.recaptcha,
	};

	return apiAction({
		method: HttpMethods.POST,
		payloadData,
		url: isClergy ? `${ApiEndpoint.ecdPlusPrc}${cleargyDetailPath}${mailMessage.distinationGuid}${sendMailPath}` : `${ApiEndpoint.ecdPlusPrc}${parishDetailPath}${mailMessage.distinationGuid}${sendMailPath}`,
		onSuccess,
		onFailure,
	});
}
